/** A door can be opened or closed. */
export enum DoorState { 
	Opened = "Opened", 
	Closed = "Closed"
}
